module.exports = __webpack_public_path__ + "static/img/FRED-RODRIGUEZ.5d3f084.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FRED-RODRIGUEZ.jpg
// module id = STeo
// module chunks = 0